import * as Types from './types';

export const User = (data: any): Types.IEntity.User => ({
  id: data.id,
  name: data.name,
  email: data.email,
  avatarUrl: data.avatarUrl,
  status: data.status,
  createdAt: data.createdAt,
  accountType: data.accountType,
  needsAccountTypeSelection: data.needsAccountTypeSelection ?? false,
  phone: data.phone,
  canManagePhone: data.canManagePhone ?? false,
  isEmailVerified: data.isEmailVerified ?? false,
  isPhoneVerified: data.isPhoneVerified ?? false,
  // Default true so a user doc without the field is never trapped at the gate.
  profileComplete: data.profileComplete ?? true,
  jobTitle: data.jobTitle,
  balanceSom: data.balanceSom ?? 0,
  learnerProfile: data.learnerProfile,
});

export const Organization = (data: any): Types.IEntity.Organization => ({
  id: data.id,
  name: data.name,
  slug: data.slug,
  logoUrl: data.logoUrl,
  tier: data.tier,
  subscriptionStatus: data.subscriptionStatus,
  companySize: data.companySize,
  useCase: data.useCase,
  hasDemoWorkspace: Boolean(data.hasDemoWorkspace),
  demoTestId: data.demoTestId ? String(data.demoTestId) : undefined,
});
